module.exports = __webpack_public_path__ + "img/dance of the sugar plum fairy.c2a3ec91.png";